<template>
  <div>
    <van-nav-bar title="发表评论" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div>
      <van-cell-group>
        <van-field
          v-model="message"
          rows="3"
          autosize
          label="评价内容"
          type="textarea"
          placeholder="请输入商品评价"
          maxlength="50"
          show-word-limit
        />
      </van-cell-group>
      <div style="display:flex; line-height:30px; padding:10px">
        <div>商品评分：</div>
        <div>
          <van-rate v-model="value" :size="25" color="#1baeae" void-icon="star" void-color="#eee" />
        </div>
        <div style="flex-grow:1;text-align:right;">
          <van-button type="primary" v-on:click="postComment()">评价</van-button>
        </div>
      </div>
    </div>
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import Vue from "vue";
import { Rate } from "vant";
import TabBar from "@/components/TabBar.vue";
// import { Uploader } from "vant";
Vue.use(Rate);
export default {
  name: "comment",
  components: {
    TabBar
  },
  data() {
    return {
      id: this.$route.params.id,
      module: this.$route.params.module,
      goodsId: this.$route.params.goodsid,
      message: "",
      value: 5,
      user: { token: "", user: {} }
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    postComment() {
      this.$http
        .post(
          this.GLOBAL.API + "s_user/order/commit",
          {
            id: this.id,
            goodsId:this.goodsId,
            module: this.module,
            score: this.value,
            comment: this.message
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.$toast(data.msg);
          } else {
            this.$toast(data.msg);
          }
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>